<template>
  <div class="trial-monitoring-page">
    <div class="trial-container">
      <div class="trial-header">
        <div class="header-content">
          <h1 class="page-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-lines-fill" viewBox="0 0 16 16">
              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"/>
            </svg>
            Suivi des inscriptions
          </h1>
          <p class="page-subtitle">Liste des 50 dernières inscriptions avec un numéro de téléphone.</p>
        </div>
        <router-link :to="{ name: 'adminDashboard' }" class="back-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
          </svg>
          Retour au dashboard
        </router-link>
      </div>

      <div class="stats-section">
        <div class="stats-card">
          <div class="stat-item">
            <div class="stat-number">{{ totalSignups }}</div>
            <div class="stat-label">Dernières inscriptions affichées</div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>Chargement des inscriptions récentes...</p>
      </div>

      <div v-else-if="usersList.length > 0" class="content-grid">
         <div class="trial-section">
            <div class="customers-list">
              <div
                v-for="user in usersList"
                :key="user.phone"
                class="customer-item"
              >
                <div class="customer-info">
                  <div class="customer-header">
                     <div class="name-container">
                       <span class="customer-name" style="font-size: 1.1rem; font-weight: 600;">
                        {{ user.first_name }} {{ user.last_name }}
                      </span>
                      <span v-if="isFromLP(user.signup_source)" class="lp-badge">LP</span>
                     </div>
                  </div>
                  <div class="customer-details">
                    <div class="customer-meta">
                      <span v-if="user.email" class="meta-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"/>
                        </svg>
                        {{ user.email }}
                      </span>
                      <span v-if="user.phone" class="meta-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
                        </svg>
                        {{ user.phone }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="customer-status">
                  <div class="trial-end">Inscrit le: {{ formatDate(user.created_at) }}</div>
                </div>
              </div>
            </div>
          </div>
      </div>
       <div v-else class="empty-state-container">
        <div class="empty-state">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-person-x" viewBox="0 0 16 16">
              <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
              <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708"/>
            </svg>
            <p>Aucune inscription récente avec numéro de téléphone n'a été trouvée.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { supabase } from "@/supabase/supabaseClient";

export default {
  name: 'RecentSignups',
  data() {
    return {
      loading: true,
      signupsData: null,
      adminPassword: null,
    }
  },
  computed: {
    usersList() {
      return this.signupsData?.recent_trials || [];
    },
    totalSignups() {
      return this.signupsData?.count || 0;
    }
  },
  methods: {
    isFromLP(source) {
      return source && source.includes('LP');
    },

    promptForPassword() {
      if (!this.adminPassword) {
        const password = prompt('Mot de passe administrateur requis:');
        if (!password) {
          throw new Error('Mot de passe requis pour accéder aux données administrateur.');
        }
        this.adminPassword = password;
      }
      return this.adminPassword;
    },

    async fetchRecentSignups() {
      this.loading = true;
      try {
        const { data } = await supabase.auth.getSession();
        const jwt = data?.session?.access_token;

        if (!jwt) {
          throw new Error('Session expirée ou utilisateur non connecté.');
        }

        const adminPassword = this.promptForPassword();

        const response = await fetch('https://api.query-juriste.com/copilot/admin/get-recent-trials', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${jwt}`,
            'Content-Type': 'application/json',
            'X-Admin-Password': adminPassword
          }
        });

        if (!response.ok) {
           if (response.status === 403) {
            this.adminPassword = null;
          }
          const errorData = await response.json();
          throw new Error(errorData.error || 'Erreur lors de la récupération des inscriptions.');
        }

        this.signupsData = await response.json();

      } catch (error) {
        console.error('Error fetching recent signups data:', error);
        alert(error.message);
      } finally {
        this.loading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    }
  },

  async mounted() {
    await this.fetchRecentSignups();
  }
}
</script>

<style scoped>
.trial-monitoring-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem 1rem;
}

.trial-container {
  max-width: 1200px;
  margin: 0 auto;
}

.trial-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  color: white;
}

.header-content {
  flex: 1;
}

.page-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.page-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 300;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.15);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.stats-section {
  margin-bottom: 2rem;
}

.stats-card {
  display: flex;
  gap: 2rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  justify-content: center;
}

.stat-item {
  text-align: center;
  flex: 0 1 300px;
}

.stat-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  color: #667eea;
  margin-bottom: 0.5rem;
}

.stat-label {
  display: block;
  font-size: 0.9rem;
  color: #718096;
  font-weight: 600;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 1rem;
  text-align: center;
  color: white;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 3px solid white;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}

.trial-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.customers-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.customer-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.25rem;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #667eea;
  transition: all 0.3s ease;
}

.customer-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.customer-info {
  flex: 1;
  overflow: hidden;
}

.customer-header {
  margin-bottom: 0.75rem;
}

.name-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.customer-name {
  margin: 0;
  font-weight: 500;
  color: #2d3748;
  font-size: 0.95rem;
}

.lp-badge {
  padding: 3px 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.customer-meta {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.9rem;
  color: #718096;
}

.customer-status {
  flex-shrink: 0;
  margin-left: 1rem;
  text-align: right;
}

.trial-end {
  font-size: 0.9rem;
  color: #718096;
  font-weight: 500;
}

.empty-state-container {
  padding: 2rem 0;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  color: #718096;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.empty-state svg {
  opacity: 0.5;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .trial-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
  .page-title {
    font-size: 2rem;
  }
  .customer-item {
    flex-direction: column;
    align-items: stretch;
  }
  .customer-status {
    margin-left: 0;
    margin-top: 1rem;
    text-align: left;
  }
}
</style>
